
import FeaturedTrackSlots from './FeaturedTrackSlots';

export default function TrackFeatureSection({ tracks, isLoading, onPlayTrack }) {
    return (
        <>
            <div className="bjnt-section-header">
                <div>
                    <h2 className="bjnt-section-title">Featured Tracks</h2>
                </div>

                <a
                    href="mailto:advertise@bajantube.com?subject=Featured%20Track%20Slot"
                    className="bjnt-playlist-play"
                >
                    Get Featured
                </a>
            </div>

            {isLoading && (
                <p className="bjnt-empty-state">Loading featured tracks...</p>
            )}

            {!isLoading && !tracks.length && (
                <section className="bjnt-featured-slot-empty">
                    <h3>Want your track featured here?</h3>
                    <p>
                        Promote your release in one of Bajantube’s featured track slots.
                    </p>

                    <a
                        href="mailto:advertise@bajantube.com?subject=Featured%20Track%20Slot"
                        className="bjnt-home-btn"
                    >
                        Get Featured
                    </a>
                </section>
            )}

            {!!tracks.length && (
                <FeaturedTrackSlots
                    tracks={tracks}
                    slotCount={8}
                    onPlayTrack={onPlayTrack}
                />
            )}
        </>
    );
}